import React, { FC } from 'react'
import { GetServerSideProps } from 'next'
import { AdType } from '@sport1/types/web'
import StandardLayout from '@/layouts/Standard'
import PageContentLayout from '@/layouts/Standard/PageContentLayout'
import { getLayoutByTag, getTagBySlug } from '@/pages/api/cms/content/tag/[id]'
import { getSport1Navigation } from '@/pages/api/cms/navigation'
import extendLive from '@/utils/seo/extendLive'
import { PageProps } from '@/types/page'
import handleRejection from '@/utils/errors/handleRejection'
import { removeLastAdsFromLayout } from '@/helpers/adHelper'

const Live: FC<PageProps> = ({ layoutData, navigation }) => {
    return (
        <StandardLayout navigation={navigation}>
            <PageContentLayout
                layoutData={removeLastAdsFromLayout({
                    layoutData,
                    adTypeToStay: AdType.OUTBRAIN_AD,
                    leftAdsIfNoToStay: true,
                })}
            />
        </StandardLayout>
    )
}

export const getServerSideProps: GetServerSideProps<PageProps> = async ctx => {
    let navigation, tag, layout

    try {
        ;[navigation, tag] = await Promise.all([getSport1Navigation(), getTagBySlug('/live')])
        layout = await getLayoutByTag(tag)
    } catch (error) {
        return handleRejection(error)
    }

    const layoutData = extendLive({ layoutProps: layout })

    const deeplink = `sport1://tag/${tag.contextId}`
    ctx.res.setHeader('deeplink', deeplink)

    return {
        props: {
            layoutData,
            navigation: {
                ...navigation,
                tag,
            },
            deeplink,
        },
    }
}

export default Live
